import React from 'react';
import { Loader2 } from 'lucide-react';

export interface KeyExtractionProcessingOverlayProps {
  show: boolean;
  onCancel: () => void;
}

export const KeyExtractionProcessingOverlay: React.FC<KeyExtractionProcessingOverlayProps> = ({
  show,
  onCancel,
}) => {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 100003,
    }}>
      <div className="spin" style={{ marginBottom: 16 }}>
        <Loader2 size={48} color="#3b82f6" />
      </div>
      <p style={{ color: '#ffffff', fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
        Extracting Power Legend
      </p>
      <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
        Analyzing legend areas for power symbols and names...
      </p>
      <button
        onClick={onCancel}
        style={{
          marginTop: 24,
          padding: '10px 24px',
          background: 'rgba(255,255,255,0.15)',
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: 8,
          color: '#ffffff',
          fontSize: 14,
          cursor: 'pointer',
          transition: 'background 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.25)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
      >
        Cancel
      </button>
    </div>
  );
};
